import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  const [email, setEmail] = useState('');
  const [isSubscribed, setIsSubscribed] = useState(false);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');

  const handleSubscribe = async (e) => {
    e.preventDefault();

    if (!email) return;

    setLoading(true);
    setMessage('');

    try {
      const response = await fetch('https://amaanativf.com/api/Subscribed_emails.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email: email,
          source: 'footer_newsletter',
        }),
      });

      const data = await response.json();

      if (response.ok) {
        setIsSubscribed(true);
        setEmail('');
        setMessage(data.message || 'Subscribed successfully');
      } else {
        setMessage(data.message || 'Subscription failed');
      }
    } catch (error) {
      setMessage('Server error. Please try again later.');
    }

    setLoading(false);
  };

  return (
    <footer className="footer">
      <div className="footer-container">

        {/* Newsletter */}
        <div className="newsletter-section">
          <div className="newsletter-content">
            <h3>Subscribe for Updates</h3>
            <p>Get latest IVF offers, fertility tips & consultation dates</p>

            <form className="subscribe-form" onSubmit={handleSubscribe}>
              <input
                type="email"
                placeholder="Enter your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="email-input"
                required
                disabled={isSubscribed}
              />

              <button
                type="submit"
                className="subscribe-btn"
                disabled={loading || isSubscribed}
              >
                {loading
                  ? 'Subscribing...'
                  : isSubscribed
                  ? 'Subscribed!'
                  : 'Subscribe'}
              </button>
            </form>

            {message && <p className="subscribe-message">{message}</p>}
          </div>
        </div>

        {/* Footer Links */}
        <div className="footer-links">

          {/* Quick Links */}
          <div className="footer-column">
            <h4>Quick Links</h4>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/contact">Contact</Link></li>
              <li><Link to="/services/ivf">Our Services</Link></li>
              <li><Link to="/bookappointment">Book Appointment</Link></li>
              <li><Link to="/career">Careers</Link></li>

            </ul>
          </div>

          {/* Services */}
          <div className="footer-column">
            <h4>Services</h4>
            <ul>
              <li><Link to="/services/iui">IUI Treatment</Link></li>
              <li><Link to="/services/ivf">IVF Treatment</Link></li>
              <li><Link to="/services/icsi">ICSI</Link></li>
              <li><Link to="/services/oocyte">Oocyte Pickup</Link></li>
              <li><Link to="/services/embryo">Embryo Transfer</Link></li>
              <li><Link to="/services/donor">Egg Donor Program</Link></li>
              <li><Link to="/services/gynae">Obstetrics & Gynaecology</Link></li>
              <li><Link to="/services/pediatrics">Pediatrics</Link></li>
              {/* <li><Link to="/bookappointment">Free Consultation</Link></li> */}
            </ul>
          </div>

          {/* Contact Info */}
          <div className="footer-column contact-column">
            <h4>Contact Info</h4>

            <ul className="contact-list">

              <li className="contact-item">
                <span className="icon">📞</span>
                <a href="tel:+919991641100">+91 9991641100</a>
              </li>

              <li className="contact-item">
                <span className="icon">📧</span>
                <a href="mailto:info@amaanativf.com">
                  info@amaanativf.com
                </a>
              </li>

              <li className="contact-item">
                <span className="icon">📍</span>
                <a
                  href="https://www.google.com/maps/search/?api=1&query=15+Medha+Tower+Kalka+Chowk+Ambala+City+India"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  15, Medha Tower, Kalka Chowk<br />
                  Ambala City, India
                </a>
              </li>

              <li className="contact-item">
                <span className="icon">🕒</span>
                <span>Mon - Sun: 10AM - 7PM</span>
              </li>

            </ul>
          </div>

        </div>
      </div>
                <hr style={{ width: '80%', margin: '0 auto' }} />
      {/* Bottom Bar */}
      <div className="footer-bottom-bar">

        <p className="footer-copy">
          {/* © 2026 copyrights with */}
           Aamanat IVF and Fertility Centre
        </p>

        <div className="footer-social">
          <a href="https://www.instagram.com/amaanativf" target="_blank" rel="noreferrer">
            <i className="fab fa-instagram"></i>
          </a>
          <a href="https://www.facebook.com/share/1JAaDyfB1d/" target="_blank" rel="noreferrer">
            <i className="fab fa-facebook-f"></i>
          </a>
          <a href="https://www.linkedin.com/company/amaanativf/" target="_blank" rel="noreferrer"><i className="fab fa-linkedin-in"></i></a>
        </div>

        <button
          className="back-to-top"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        >
          Back to top
        </button>

      </div>
    </footer>
  );
};

export default Footer;